import React from 'react'
import StoryItemText from './StoryItemText'
import StoryItemImage from './StoryItemImage'
import StoryItemVideo from './StoryItemVideo'
import StoryItemInlineAd from './StoryItemInlineAd'
import StoryItemBannerAd from './StoryItemBannerAd'

function StoryItemFactory(asset, adClick, api, width, height) {
  switch (asset.type) {
    case 'IMAGE':
      return <StoryItemImage key={asset.id} asset={asset} api={api} width={width} height={height} />
    case 'TEXT':
      return <StoryItemText key={asset.id} asset={asset} />
    case 'VIDEO':
      return <StoryItemVideo key={asset.id} asset={asset} />
    case 'INLINE_AD':
      return <StoryItemInlineAd key={asset.id} asset={asset} adClick={adClick} api={api} width={width} height={height} />
    case 'BANNER_AD':
      return <StoryItemBannerAd key={asset.id} asset={asset} adClick={adClick} api={api} width={width} height={height} />
    default:
      return null
  }
}

export default StoryItemFactory
